module.exports = __webpack_public_path__ + "1bac4a675a69c1d3683a5238e5f6a607.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/bella-flowy-racerback-tank-black-marble.jpg
// module id = 825
// module chunks = 0